import { each, findIndex } from 'lodash-es';

function getRandomColor() {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i += 1) {
    color += letters[Math.floor(Math.random() * 16)];
  }

  return color;
}

const state = {
  connectedUsers: {},
  userOrder: [],
  userColors: {},
  loading: false,
  showScreensModal: false,
  showUpdateProductionModal: false,
  showHighlightsModal: false,

  // Whether we are _currently_ connected to the Socket
  // server or not. Used to toggle the overlay UI
  // to prevent user's from working.
  isSocketConnected: false,

  // Whether we received a disconnect event or not.
  // Used to determine if we need to rejoin socket rooms.
  // Kept separate from isSocketConnected to avoid extra
  // requests on initial load of a production.
  isDisconnected: false,

  // List of connected users by production
  byProduction: {},
};

const actions = {
  socket_connect(context) {
    if (context.state.isDisconnected) {
      // If we were previously disconnected, make sure to rejoin the production room.
      // The socketIO 'reconnect' event isn't always triggered if the disconnect happened
      // at the client level, but it's safe to retry duplicate times.
      context.dispatch('socket_reconnect');
    }

    context.commit('SET_SOCKET_CONNECTED', true);
  },

  socket_disconnect(context) {
    context.commit('SET_SOCKET_CONNECTED', false);
  },

  socket_clients(context, payload) {
    context.commit('ADD_CLIENTS', payload);
  },

  socket_joined(context, payload) {
    context.commit('ADD_CLIENT', payload);
  },

  socket_left(context, payload) {
    context.commit('REMOVE_CLIENT', payload);
  },

  socket_connectedUsersByProduction(context, payload) {
    context.commit('MERGE_CONNECTED_USERS', payload);
  },

  /**
   * Get full list of all connected users for loaded productions on the dashboard.
   */
  getConnectedUsers(context) {
    // To cut down on payload size, we'll just get what we are missing
    const loadedIds = Object.keys(context.state.byProduction).map((id) => parseInt(id, 10));
    const productionIds = context.rootState.production.productions
      .map((p) => p._id)
      .filter((id) => !loadedIds.includes(id));

    const opts = { production_ids: productionIds };

    // Get list of users per production.
    // This will also subscribe the client to specific rooms for each production,
    // so we'll get changes when somebody joins.
    $socket.emit('getConnectedUsers', opts, (data) => {
      context.commit('MERGE_CONNECTED_USERS', data);
    });
  },

  reset(context) {
    context.commit('RESET_ALL');
  },

  toggleScreensModal(context) {
    context.commit('SET_MANAGE_SCREENS_MODAL_VISIBILITY', !state.showScreensModal);
  },

  toggleUpdateProductionModal(context) {
    context.commit('SET_UPDATE_PRODUCTION_MODAL_VISIBILITY', !state.showUpdateProductionModal);
  },

  toggleHighlightsModal(context) {
    context.commit('SET_HIGHLIGHTS_MODAL_VISIBILITY', !state.showHighlightsModal);
  },
};

const mutations = {
  /* eslint-disable no-shadow, no-param-reassign */

  MERGE_CONNECTED_USERS(state, users) {
    state.byProduction = {
      ...state.byProduction,
      ...users,
    };
  },

  ADD_CLIENTS(state, payload) {
    payload.clients.forEach((client) => {
      if (state.userColors[client.client_id]) {
        client.color = state.userColors[client.client_id];
      } else {
        client.color = getRandomColor();

        // Save for later
        state.userColors[client.client_id] = client.color;
      }

      if(!state.connectedUsers[client.client_id]) {
        state.connectedUsers[client.client_id] = client;
      }

      if (state.userOrder.indexOf(client.client_id) === -1) {
        state.userOrder.push(client.client_id);
      }
    });

    each(state.connectedUsers, (client) => { // do a diff to find what to remove
      const index = findIndex(payload.clients, (o) => o.client_id === client.client_id);
      if(index === -1) { // we dont have this client anymore
        delete state.connectedUsers[client.client_id];
        state.userOrder.splice(state.userOrder.indexOf(client.client_id),1);
      }
    });

    state.connectedUsers = { ...state.connectedUsers};
  },

  ADD_CLIENT(state, payload) {
    payload.client.color = getRandomColor();
    state.connectedUsers[payload.client.client_id] = payload.client;

    if (state.userOrder.indexOf(payload.client.client_id) === -1) {
      state.userOrder.push(payload.client.client_id);
    }

    // Save this for later
    state.userColors[payload.client.client_id] = payload.client.color;

    state.connectedUsers = { ...state.connectedUsers};
  },

  REMOVE_CLIENT(state, payload) {
    if (payload.client && state.connectedUsers[payload.client.client_id]) {
      delete state.connectedUsers[payload.client.client_id];
      state.userOrder.splice(state.userOrder.indexOf(payload.client.client_id),1);

      state.connectedUsers = { ...state.connectedUsers};
    }
  },

  RESET_ALL(state) {
    state.userColors = {};
    state.connectedUsers = {};
    state.userOrder = [];

    state.connectedUsers = { ...state.connectedUsers };
  },

  SET_INTERCOM(state, payload) {
    state.intercomOpen = payload;
  },

  SET_MANAGE_SCREENS_MODAL_VISIBILITY(state, payload) {
    state.showScreensModal = payload;
  },

  SET_UPDATE_PRODUCTION_MODAL_VISIBILITY(state, payload) {
    state.showUpdateProductionModal = payload;
  },

  SET_HIGHLIGHTS_MODAL_VISIBILITY(state, payload) {
    state.showHighlightsModal = payload;
  },

  SET_SOCKET_CONNECTED(state, payload) {
    state.isSocketConnected = payload;

    if (!payload) {
      state.isDisconnected = true;
    }
  },
};

export default {
  state,
  actions,
  mutations,
};
